export default __webpack_public_path__ + "static/media/012-day.c140fd72.svg";